// [data-theme] on <html> drives every --color-* token (see application.css).
// Turbo Drive replaces <body> and merges <head> on every visit, but of the
// live <html> element's own attributes it only ever syncs lang/dir — see
// PageRenderer#render in @hotwired/turbo — never arbitrary data attributes.
// Left alone, a theme changed in Settings would revert the moment a
// Turbo-intercepted link is clicked, back to whatever the very first page of
// the session rendered. This applies the same sync Turbo already does for
// lang/dir, just for data-theme: turbo:before-render's newBody is parsed
// from the incoming document, so its ownerDocument still has the fetched
// page's own <html data-theme> to read.
// Four attributes now, all of them settings the server renders onto <html>
// and Turbo would otherwise drop: the theme, the two the browser needs to
// format a date the way the account asked (see lib/dateStyle.ts), and whether
// money is covered (see lib/financesCovered.ts).
// `money` joins them: the curtain is a per-person setting the server renders
// onto <html>, and a curtain that opened again on the next link would be worse
// than no curtain — you would not know it had.
const SYNCED = ['theme', 'dateStyle', 'weekStart', 'money'] as const

export function initThemeSync() {
  document.addEventListener('turbo:before-render', (event) => {
    const newBody = (event as CustomEvent<{ newBody: HTMLElement }>).detail.newBody
    const incoming = newBody.ownerDocument.documentElement.dataset

    SYNCED.forEach((key) => {
      const value = incoming[key]
      if (value) document.documentElement.dataset[key] = value
      else delete document.documentElement.dataset[key]
    })
  })
}
